import {
    RadioBackgroundElement,
    RadioElement,
    RadioInnerCircleElement,
    RadioInputElement,
    RadioOuterCircleElement,
} from './style';

export interface RadioProps {
    className?: string;
    checked?: boolean;
    disabled?: boolean;
    children?: React.ReactNode;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
    inputHidden?: boolean;
    value?: string;
}

const Radio = ({ className, checked, disabled, inputHidden, children, onChange, ...other }: RadioProps) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (!disabled && onChange) {
            onChange(e, !checked);
        }
    };

    return (
        <RadioElement className={className} $disabled={disabled} inputHidden={inputHidden}>
            <RadioInputElement
                {...other}
                type="radio"
                checked={checked}
                disabled={disabled}
                onChange={handleChange}
                aria-checked={checked}
            />
            <RadioBackgroundElement aria-hidden>
                <RadioOuterCircleElement checked={checked} disabled={disabled} />
                <RadioInnerCircleElement checked={checked} disabled={disabled} />
            </RadioBackgroundElement>
        </RadioElement>
    );
};

export default Radio;
